import React, { FC } from 'react';
import Grid, { GridProps } from '@material-ui/core/Grid';

const FormCol: FC<GridProps> = ({ children, ...props }) => {
  return (
    <Grid item xs zeroMinWidth {...props}>
      {children}
    </Grid>
  );
};

export default FormCol;
